import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonth = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 38,
	viewBox: "0 0 41 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_465_3200)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 5,
				y: 5,
				width: 31,
				height: 28,
				rx: 5,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5901 18.7H17.5621L20.0821 25H19.0561L18.3811 23.245H15.7711L15.0961 25H14.0701L16.5901 18.7ZM17.0761 19.807C17.0581 19.861 17.0371 19.921 17.0131 19.987C16.9951 20.041 16.9711 20.104 16.9411 20.176C16.9171 20.248 16.8901 20.326 16.8601 20.41L16.0951 22.399H18.0571L17.2921 20.41C17.2621 20.326 17.2321 20.248 17.2021 20.176C17.1781 20.104 17.1571 20.041 17.1391 19.987C17.1151 19.921 17.0941 19.861 17.0761 19.807ZM20.7633 20.536H21.6813V21.22C21.8193 20.998 22.0293 20.809 22.3113 20.653C22.5993 20.491 22.9173 20.41 23.2653 20.41C23.5413 20.41 23.8053 20.464 24.0573 20.572C24.3093 20.68 24.5283 20.836 24.7143 21.04C24.9003 21.238 25.0473 21.484 25.1553 21.778C25.2693 22.072 25.3263 22.402 25.3263 22.768C25.3263 23.128 25.2693 23.455 25.1553 23.749C25.0473 24.037 24.8973 24.283 24.7053 24.487C24.5133 24.691 24.2853 24.85 24.0213 24.964C23.7633 25.072 23.4843 25.126 23.1843 25.126C22.8603 25.126 22.5633 25.06 22.2933 24.928C22.0293 24.796 21.8253 24.616 21.6813 24.388V26.836H20.7633V20.536ZM23.0043 21.256C22.8123 21.256 22.6323 21.292 22.4643 21.364C22.2963 21.436 22.1493 21.541 22.0233 21.679C21.8973 21.811 21.7983 21.97 21.7263 22.156C21.6543 22.342 21.6183 22.546 21.6183 22.768C21.6183 22.996 21.6543 23.203 21.7263 23.389C21.7983 23.569 21.8973 23.728 22.0233 23.866C22.1493 23.998 22.2963 24.1 22.4643 24.172C22.6323 24.244 22.8123 24.28 23.0043 24.28C23.1963 24.28 23.3763 24.244 23.5443 24.172C23.7123 24.1 23.8593 23.998 23.9853 23.866C24.1113 23.728 24.2103 23.569 24.2823 23.389C24.3543 23.203 24.3903 22.996 24.3903 22.768C24.3903 22.546 24.3543 22.342 24.2823 22.156C24.2103 21.97 24.1113 21.811 23.9853 21.679C23.8593 21.541 23.7123 21.436 23.5443 21.364C23.3763 21.292 23.1963 21.256 23.0043 21.256ZM28.6942 21.328C28.5742 21.292 28.4572 21.274 28.3432 21.274C28.1812 21.274 28.0312 21.31 27.8932 21.382C27.7552 21.448 27.6352 21.544 27.5332 21.67C27.4372 21.79 27.3622 21.934 27.3082 22.102C27.2542 22.27 27.2272 22.453 27.2272 22.651V25H26.3092V20.536H27.2272V21.292C27.3472 21.028 27.5152 20.815 27.7312 20.653C27.9472 20.491 28.2082 20.41 28.5142 20.41C28.5742 20.41 28.6282 20.416 28.6762 20.428C28.7302 20.434 28.7872 20.443 28.8472 20.455L28.6942 21.328Z",
			fill: "#464646"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 17,
			y1: 10.5,
			x2: 25,
			y2: 10.5,
			stroke: "#625fe3"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_465_3200",
			x: 0,
			y: 0,
			width: 41,
			height: 38,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_465_3200"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_465_3200",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgMonth;
